import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";

export class RootBannerSection {
  private readonly swiperSection: Element;
  private readonly swiper: Swiper;
  private swiperAlreadyTracked?: number[];

  constructor(swiperSection: Element) {
    this.swiperSection = swiperSection;
    const swiperContainer = this.swiperSection.getElementsByClassName("swiper-container")[0];
    this.swiper = new Swiper(swiperContainer, this.initParams());
    this.swiper.loaded = true;
  }

  private initParams() {
    const nextEl = this.swiperSection.getElementsByClassName("swiper-button-next")[0];
    const prevEl = this.swiperSection.getElementsByClassName("swiper-button-prev")[0];

    return {
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      navigation: {
        nextEl,
        prevEl,
      },
      on: {
        init,
        slideChange,
      },
      preloadImages: false,
      simulateTouch: false,
      spaceBetween: 8,
    };
  }
}

/**
 * init method for swiper.
 * Out of class scope because of swiper context as "this" in init param object.
 * this.swiper in class-scope not initialized at this time
 */
function init() {
  Array.from<Element>(this.slides).forEach((slide) => {
    Array.from(slide.getElementsByClassName("ga-swiper-promo-element")).forEach((elem) => {
      elem.addEventListener("click", (evt) => {
        Tracking.sendPromoClick(evt.currentTarget as HTMLElement);
        Tracking.sendEvent("Homepage.SwiperBanner.Slide.Clicked");
      });
    });
  });
}

function slideChange() {
  this.swiperAlreadyTracked = this.swiperAlreadyTracked || [];
  if (this.swiperAlreadyTracked.indexOf(this.realIndex) === -1) {
    Array.from<HTMLElement>(this.slides[this.activeIndex].getElementsByClassName("ga-swiper-promo-element")).forEach(
      (elem) => {
        /**
         * Responsive Button-Einblendung, tracke
         * nur den, der auch grad sichtbar ist
         */
        if (elem.offsetWidth > 0) {
          Tracking.sendPromoView(elem);
        }
      },
    );
    this.swiperAlreadyTracked.push(this.realIndex);
  }
  if (this.loaded) {
    Tracking.sendEvent("Homepage.SwiperBanner.Swiped");
  }
}
